import AcupunctureIcon from '../icons/featureIcons/AcupunctureIcon';
import AnteNatalIcon from '../icons/featureIcons/AnteNatalIcon';
import AssistedIcon from '../icons/featureIcons/AssistedIcon';
import AudiologyIcon from '../icons/featureIcons/AudiologyIcon';
import BackNeckIcon from '../icons/featureIcons/BackNeckIcon';
import BloodGlucoseIcon from '../icons/featureIcons/BloodGlucoseIcon';
import BloodIcon from '../icons/featureIcons/BloodIcon';
import BoneIcon from '../icons/featureIcons/BoneIcon';
import BrainIcon from '../icons/featureIcons/BrainIcon';
import BreastIcon from '../icons/featureIcons/BreastIcon';
import CataractsIcon from '../icons/featureIcons/CataractsIcon';
import ChemoTherapyIcon from '../icons/featureIcons/ChemoTherapyIcon';
import ChinesseMedicineIcon from '../icons/featureIcons/ChinesseMedicineIcon';
import ChiropracticIcon from '../icons/featureIcons/ChiropracticIcon';
import DentalIcon from '../icons/featureIcons/DentalIcon';
import DiabetesIcon from '../icons/featureIcons/DiabetesIcon';
import DialysisIcon from '../icons/featureIcons/DialysisIcon';
import DigestiveIcon from '../icons/featureIcons/DigestiveIcon';
import EarIcon from '../icons/featureIcons/EarIcon';
import EndodonticIcon from '../icons/featureIcons/EndodonticIcon';
import ExerciseIcon from '../icons/featureIcons/ExerciseIcon';
import EyeIcon from '../icons/featureIcons/EyeIcon';
import EyeTherapyIcon from '../icons/featureIcons/EyeTherapyIcon';
import GastrointestianlIcon from '../icons/featureIcons/GastrointestianlIcon';
import GeneralDentalIcon from '../icons/featureIcons/GeneralDentalIcon';
import GynaecologyIcon from '../icons/featureIcons/GynaecologyIcon';
import HealthManagementIcon from '../icons/featureIcons/HealthManagementIcon';
import Hearing from '../icons/featureIcons/Hearing';
import HeartIcon from '../icons/featureIcons/HeartIcon';
import HerniaIcon from '../icons/featureIcons/HerniaIcon';
import HomeNursingIcon from '../icons/featureIcons/HomeNursingIcon';
import HospitalPsychiatricIcon from '../icons/featureIcons/HospitalPsychiatricIcon';
import ImplantationIcon from '../icons/featureIcons/ImplantationIcon';
import InsulinPumpsIcon from '../icons/featureIcons/InsulinPumpsIcon';
import JointIcon from '../icons/featureIcons/JointIcon';
import JointReplacementsIcons from '../icons/featureIcons/JointReplacementsIcons';
import LungIcon from '../icons/featureIcons/LungIcon';
import MajorIcon from '../icons/featureIcons/MajorIcon';
import MaleIcon from '../icons/featureIcons/MaleIcon';
import MiscarriageIcon from '../icons/featureIcons/MiscarriageIcon';
import NonPbs from '../icons/featureIcons/NonPbs';
import OccupationalIcon from '../icons/featureIcons/OccupationalIcon';
import OpticalIcon from '../icons/featureIcons/OpticalIcon';
import OrthoticsIcon from '../icons/featureIcons/OrthoticsIcon';
import OsteopathyIcon from '../icons/featureIcons/OsteopathyIcon';
import PainIcon from '../icons/featureIcons/PainIcon';
import PainManagementIcon from '../icons/featureIcons/PainManagementIcon';
import PalliativeIcon from '../icons/featureIcons/PalliativeIcon';
import PlasticIcon from '../icons/featureIcons/PlasticIcon';
import PodiatricIcon from '../icons/featureIcons/PodiatricIcon';
import PregnancyIcon from '../icons/featureIcons/PregnancyIcon';
import PshychologyIcon from '../icons/featureIcons/PshychologyIcon';
import PshysiotherapyIcon from '../icons/featureIcons/PshysiotherapyIcon';
import RehabIcon from '../icons/featureIcons/RehabIcon';
import RemedialMassageIcon from '../icons/featureIcons/RemedialMassageIcon';
import SkinIcon from '../icons/featureIcons/SkinIcon';
import SleepIcon from '../icons/featureIcons/SleepIcon';
import TonsilsIcon from '../icons/featureIcons/TonsilsIcon';
import VaccinationsIcon from '../icons/featureIcons/VaccinationsIcon';
import WeightLossIcon from '../icons/featureIcons/WeightLossIcon';
import SpeechTherapyIcon from '../icons/featureIcons/SpeechTherapyIcon';
import KydneyIcon from '../icons/featureIcons/KydneyIcon';

export interface Feature {
  name: string;
  icon: React.ReactElement;
}

export const HIF_IFRAME_URL_UAT =
  'https://uat.externaliframe.hasnet.net.au/HIF/UAT/HIF_HealthDeal_IFrame_2.aspx';

export const HIF_IFRAME_URL_PROD =
  'https://prd.externaliframe.hasnet.net.au/HIF/PRD/HIF_HealthDeal_Prod_IFrame_2.aspx';

export const australiaStates = [
  'New South Wales',
  'Victoria',
  'Queensland',
  'South Australia',
  'Western Australia',
  'Tasmania',
  'Northern Territory',
  'Australian Capital Territory',
];

export const hospitalCoverFeatures: Feature[] = [
  { name: 'Bone, Joint and Muscle', icon: <BoneIcon /> },
  { name: 'Cataracts', icon: <CataractsIcon /> },
  {
    name: 'Chemotherapy, Radiotherapy and Immunotherapy for Cancer',
    icon: <ChemoTherapyIcon />,
  },
  { name: 'Dental Surgery', icon: <DentalIcon /> },
  {
    name: 'Dialysis For Chronic Kidney Failure',
    icon: <DialysisIcon />,
  },
  { name: 'Gastrointestinal Endoscopy', icon: <GastrointestianlIcon /> },
  { name: 'Heart And Vascular System', icon: <HeartIcon /> },
  { name: 'Hospital Psychiatric Services', icon: <HospitalPsychiatricIcon /> },
  { name: 'Joint Reconstructions', icon: <JointIcon /> },
  { name: 'Joint Replacements', icon: <JointReplacementsIcons /> },
  { name: 'Palliative Care', icon: <PalliativeIcon /> },
  { name: 'Pregnancy And Birth', icon: <PregnancyIcon /> },
  { name: 'Rehabilitation', icon: <RehabIcon /> },
  { name: 'Skin', icon: <SkinIcon /> },
  { name: 'Weight Loss Surgery', icon: <WeightLossIcon /> },
  { name: 'Assisted Reproductive Services', icon: <AssistedIcon /> },
  { name: 'Back, Neck and Spine', icon: <BackNeckIcon /> },
  { name: 'Blood', icon: <BloodIcon /> },
  { name: 'Brain And Nervous System', icon: <BrainIcon /> },
  { name: 'Breast Surgery (Medically Necessary)', icon: <BreastIcon /> },
  {
    name: 'Diabetes Management (Excluding Insulin Pumps)',
    icon: <DiabetesIcon />,
  },
  { name: 'Digestive System', icon: <DigestiveIcon /> },
  { name: 'Ear, Nose and Throat', icon: <EarIcon /> },
  { name: 'Eye (Not Cataracts)', icon: <EyeIcon /> },
  { name: 'Gynaecology', icon: <GynaecologyIcon /> },
  { name: 'Hernia And Appendix', icon: <HerniaIcon /> },
  { name: 'Implantation Of Hearing Devices', icon: <ImplantationIcon /> },
  { name: 'Insulin Pumps', icon: <InsulinPumpsIcon /> },
  { name: 'Kidney And Bladder', icon: <KydneyIcon /> },
  { name: 'Lung And Chest', icon: <LungIcon /> },
  { name: 'Male Reproductive System', icon: <MaleIcon /> },
  {
    name: 'Miscarriage And Termination Of Pregnancy',
    icon: <MiscarriageIcon />,
  },
  { name: 'Pain Management', icon: <PainIcon /> },
  { name: 'Pain Management With Device', icon: <PainManagementIcon /> },
  {
    name: 'Plastic and Reconstructive Surgery (Medically Necessary)',
    icon: <PlasticIcon />,
  },
  {
    name: 'Podiatric Surgery (Provided by a Registered Podiatric Surgeon)',
    icon: <PodiatricIcon />,
  },
  { name: 'Sleep Studies', icon: <SleepIcon /> },
  { name: 'Tonsils, Adenoids and Grommets', icon: <TonsilsIcon /> },
];
export const monthMap: Record<string, string> = {
  January: '01',
  February: '02',
  March: '03',
  April: '04',
  May: '05',
  June: '06',
  July: '07',
  August: '08',
  September: '09',
  October: '10',
  November: '11',
  December: '12',
};

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const extrasCoverFeatures = [
  { name: 'General Dental', icon: <GeneralDentalIcon /> },
  { name: 'Major Dental', icon: <MajorIcon /> },
  { name: 'Optical', icon: <OpticalIcon /> },
  { name: 'Physiotherapy', icon: <PshysiotherapyIcon /> },
  { name: 'Chiropractic', icon: <ChiropracticIcon /> },
  { name: 'Remedial Massage', icon: <RemedialMassageIcon /> },
  { name: 'Psychology', icon: <PshychologyIcon /> },
  { name: 'Hearing Aids', icon: <Hearing /> },
  { name: 'Acupuncture', icon: <AcupunctureIcon /> },
  { name: 'Ante-Natal/Post-Natal Classes', icon: <AnteNatalIcon /> },
  { name: 'Audiology', icon: <AudiologyIcon /> },
  { name: 'Blood Glucose Monitors', icon: <BloodGlucoseIcon /> },
  { name: 'Chinese Medicine', icon: <ChinesseMedicineIcon /> },
  { name: 'Dietetics/Dietary Advice', icon: <DiabetesIcon /> },
  { name: 'Endodontic Services', icon: <EndodonticIcon /> },
  { name: 'Exercise Physiology', icon: <ExerciseIcon /> },
  { name: 'Eye Therapy (Orthoptics)', icon: <EyeTherapyIcon /> },
  {
    name: 'Health Management/Healthy Lifestyle',
    icon: <HealthManagementIcon />,
  },
  { name: 'Home Nursing', icon: <HomeNursingIcon /> },
  { name: 'Non-Pbs Pharmaceuticals', icon: <NonPbs /> },
  { name: 'Occupational Therapy', icon: <OccupationalIcon /> },
  { name: 'Orthodontics', icon: <GeneralDentalIcon /> },
  { name: 'Orthotics (Podiatric Orthoses)', icon: <OrthoticsIcon /> },
  { name: 'Osteopathy', icon: <OsteopathyIcon /> },
  { name: 'Podiatry', icon: <PodiatricIcon /> },
  { name: 'Speech Therapy', icon: <SpeechTherapyIcon /> },
  { name: 'Vaccinations', icon: <VaccinationsIcon /> },
];

export const bupaYourChoiceBenefits = [
  { title: 'Alternate Therapies', code: 'SSCDN' },
  { title: 'Chiropractic & Osteopathy', code: 'SSCCR' },
  { title: 'General Dental', code: 'SSCGD' },
  { title: 'Health Management', code: 'SSCLW' },
  { title: 'Major Dental & Endodontic', code: 'SSC34' },
  { title: 'Optical', code: 'SSC08' },
  { title: 'Orthodontic', code: 'SSC17' },
  { title: 'Non PBS Pharmaceuticals', code: 'SSC05' },
  { title: 'Physiotherapy', code: 'SSC06' },
  { title: 'Podiatry', code: 'SSC10' },
  {
    title: 'Speech, Eye & Occupational therapies',
    code: 'SSCSE',
  },
];

export const bupaFlextrasBenefits = [
  { title: 'Acupuncture', code: 'SSCAC' },
  { title: 'Ante Natal - Midwife', code: 'SSCMA' },
  { title: 'Chinese Herbalism', code: 'SSCCH' },
  { title: 'Chiropractic & Osteopathy', code: 'SSCCR' },
  { title: 'Dietary', code: 'SSCDT' },
  { title: 'Mental Health', code: 'SSCMH' },
  { title: 'Exercise Physiology', code: 'SSCEP' },
  { title: 'Eye Therapy', code: 'SSCET' },
  { title: 'Podiatry & Foot Orthotics', code: 'SSCPO' },
  { title: 'General Dental', code: 'SSCDG' },
  { title: 'Home Nursing', code: 'SSCHN' },
  { title: 'Major Dental & Endodontic', code: 'SSCMD' },
  { title: 'Non PBS Pharmaceuticals', code: 'SSC05' },
  { title: 'Occupational Therapy', code: 'SSCOT' },
  { title: 'Optical', code: 'SSC08' },
  { title: 'Orthodontic', code: 'SSC17' },
  { title: 'Physiotherapy', code: 'SSCPH' },
  { title: 'Remedial Massage', code: 'SSCRM' },
  { title: 'Speech Therapy', code: 'SSCST' },
];

export const DATE_LIST = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
];

export const MONTH_LIST = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
];

export const TITLE_LIST = ['Dr', 'Miss', 'Mr', 'Mrs', 'Ms', 'Mx'];

export const MEDICARE_CARD_COLOURS = [
  'Green',
  'Blue',
  'Yellow',
  'No Medicare Card',
];

export const PAYMENT_METHODS = ['Bank Account', 'Credit Card'];

export const LIBS = ['places'];

export const STATE_MAP = {
  'New South Wales': 1,
  Queensland: 2,
  'South Australia': 3,
  Tasmania: 4,
  Victoria: 5,
  'Western Australia': 6,
  'Australian Capital Territory': 7,
  'Northern Territory': 8,
};

export const DEFINITIONS = {
  LHC: 'Lifetime Health Cover (LHC) loading is an additional cost added to your private health insurance premium if you take out hospital cover after the age of 31. You can often find your specific LHC percentage by logging into your online member area with your existing health fund. The number in the box below represents the maximum loading percentage for your age, which we use to ensure we do not underquote you. If you know your exact LHC percentage, you can enter any percentage you want.',
};
